(function () {
  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AUD';
    var locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en-AU';
    var formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
    return formatted.replace('A$', '$').replace('AU$', '$');
  }

  function initCompleteKit(section) {
    if (!section || section.dataset.kitReady === "true") return;
    section.dataset.kitReady = "true";

    const options = section.querySelectorAll("[data-kit-option]");
    const kitPanels = section.querySelectorAll("[data-kit-panel]");
    const popup = section.querySelector("[data-kit-popup]");
    const popupPanels = section.querySelectorAll("[data-kit-popup-panel]");
    const openBtn = section.querySelector("[data-kit-popup-open]");
    const closeBtns = section.querySelectorAll("[data-kit-popup-close]");
    const dialog = section.querySelector("[data-kit-popup-dialog]");

    function switchPanels(index) {
      kitPanels.forEach(function (p) {
        const isActive = p.getAttribute("data-kit-panel") === String(index);
        p.classList.toggle("is-active", isActive);
        p.hidden = !isActive;
      });
      popupPanels.forEach(function (p) {
        const isActive = p.getAttribute("data-kit-popup-panel") === String(index);
        p.classList.toggle("is-active", isActive);
        p.hidden = !isActive;
      });
    }

    function updateLeftColumn(option) {
      const singlePrice = Number(option.getAttribute("data-kit-single-price"));
      const installment = Number(option.getAttribute("data-kit-single-installment"));

      const ctaPrice = section.querySelector("[data-kit-cta-price]");
      if (ctaPrice) ctaPrice.textContent = formatMoney(singlePrice);

      const instValue = section.querySelector("[data-kit-installments-value]");
      if (instValue) {
        instValue.textContent = "Or 4 × " + formatMoney(installment) + " / month";
      }

      const starCount = Number(option.getAttribute("data-kit-star-count")) || 0;
      const reviewCount = Number(option.getAttribute("data-kit-review-count")) || 0;
      const stars = section.querySelectorAll("[data-kit-rating] .complete-kit__star");
      stars.forEach(function (star, i) {
        star.classList.toggle("complete-kit__star--filled", i < starCount);
      });
      const reviews = section.querySelector("[data-kit-reviews]");
      if (reviews) {
        reviews.textContent = reviewCount > 0 ? reviewCount + " reviews" : "";
      }
    }

    function applyOption(option) {
      const index = option.getAttribute("data-kit-index");

      options.forEach(function (item) {
        const isSelected = item === option;
        item.classList.toggle("is-selected", isSelected);
        item.setAttribute("aria-checked", isSelected ? "true" : "false");
      });

      switchPanels(index);
      updateLeftColumn(option);
    }

    function openPopup() {
      if (!popup) return;
      popup.hidden = false;
      document.body.style.overflow = "hidden";
      if (dialog) dialog.focus();
    }

    function closePopup() {
      if (!popup || popup.hidden) return;
      popup.hidden = true;
      document.body.style.overflow = "";
      if (openBtn) openBtn.focus();
    }

    options.forEach(function (option) {
      option.addEventListener("click", function (event) {
        if (event.target.closest(".complete-kit__view")) return;
        applyOption(option);
      });

      option.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        applyOption(option);
      });
    });

    if (openBtn) {
      openBtn.addEventListener("click", openPopup);
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", closePopup);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closePopup();
    });

    document.addEventListener("complete-kit:open", function (event) {
      const detail = event.detail || {};
      let option = null;

      if (detail.variantId) {
        option = section.querySelector(
          '[data-kit-option][data-kit-single-id="' + detail.variantId + '"]'
        );
      }

      if (!option && detail.index != null) {
        option = section.querySelector(
          '[data-kit-option][data-kit-index="' + detail.index + '"]'
        );
      }

      if (option) applyOption(option);
      openPopup();
    });

    if (dialog) {
      dialog.setAttribute("tabindex", "-1");
    }

    async function handleAddToCart(btn) {
      const variantId = Number(btn.getAttribute("data-variant-id"));
      if (!variantId || btn.disabled) return;

      const originalHtml = btn.innerHTML;
      try {
        btn.disabled = true;
        btn.textContent = "Adding...";
        await addToCart(variantId, 1);
        closePopup();
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
        );
      } catch (error) {
        console.error("Complete kit add to cart error:", error);
      } finally {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      }
    }

    section.querySelectorAll("[data-kit-add-single]").forEach(function (btn) {
      btn.addEventListener("click", function () { handleAddToCart(btn); });
    });

    section.querySelectorAll("[data-kit-add-bundle]").forEach(function (btn) {
      btn.addEventListener("click", function () { handleAddToCart(btn); });
    });

    section.querySelectorAll("[data-kit-bundle-add]").forEach(function (btn) {
      btn.addEventListener("click", function () { handleAddToCart(btn); });
    });
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-complete-kit]").forEach(initCompleteKit);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
